import { checkStopStatus, checkServiceStatus } from "react/utils/utils";

Greenmile.RouteProgress = Greenmile.RouteProgress || {};

Greenmile.RouteProgress.Grid = function () {

    this.setEntity = function (entity) {
        this.entity = entity;

        App.Forms[this.entity].timeSlices = [];
        App.Forms[this.entity].gantData = [];
    };

    this.showGrid = function () {
        const defaultColumns = Greenmile.RouteProgress.StaticData.defaultColumns();
        const options = {
            entity: this.entity,
            enableColumnReorder: false,
            rowHeight: 30,
            columnCheckBox: {
                show: false,
                checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
                options: {
                    checkOnClickRow: true
                }
            },
            columnEdit: {
                show: false
            },
            headerMenu: {
                headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
            },
            actions: ["SAVE_LAYOUT", "CUSTOMIZE_COLUMNS"],
            multiColumnSort: true,
            frozenColumn: defaultColumns.length - 1
        };

        const container = `#${this.entity} #form_and_grid`;
        const columns = defaultColumns;
        const controlUpdate = new Monet.Grid.ControlUpdate();

        const dataView = new Monet.Grid.DataProvider(columns, null, this.entity);
        const grid = new Monet.Grid.GenericGrid(container, dataView, columns, options);

        controlUpdate.setEntityToNamespace('RouteProgress');

        App.Forms[this.entity].table = grid;
        App.Forms[this.entity].dataProvider = dataView;
        App.Forms[this.entity].controlUpdater = controlUpdate;


    };

    this.generateTimeColumns = function (bound) {
        var utils = new Greenmile.RouteProgress.Utils();
        var min = new Date(bound.min).getTime();
        var max = new Date(bound.max).getTime();
        var dif = max - min;
        var timeSliceTotal = "";
        var duration = utils.getDuration(dif);
        var totalOfHours = duration.weeks * 168 + duration.days * 24 + duration.hours + 1;
        var columns = [];
        App.Forms.RouteProgress.bound = {
            min: min,
            max: max
        };

        App.Forms.RouteProgress.timeSlices = [];
        if (min !== 0) {
            for (var i = 0; i <= totalOfHours; i++) {
                const date = new Date(min);

                date.setMinutes(0);
                date.setHours(date.getHours() + i);

                App.Forms.RouteProgress.timeSlices.push(date);

            }
            timeSliceTotal = this.createTimeSliceHeaders();
        }

        columns.push({
            id: "hour_0",
            name: timeSliceTotal,
            field: "hour_0",
            width: (totalOfHours + 1) * 120,
            cssClass: "cell-row",
            sortable: false,
            resizable: false,
            formatter: this.gridColumnFormatter
        });

        return columns;

    };

    this.gridColumnFormatter = function (row, cell, value) {

        return value;

    };

    this.transformAllDataInGant = function (routesCollection) {
        routesCollection.models.forEach(route => {
            route.set({
                'hour_0': this.createRouteStatus(route.get('stops'), route)
            });
        });
    };

    this.createRouteStatus = function (stops, route) {

        var html = "";

        html += this.createCurrentTime();
        html += this.transformStopsInGant(stops, route);
        html += this.createTimeSliceColumns();

        return html;

    };

    this.transformStopsInGant = function (stops, route) {
        var sliceContainers = document.createElement('div');
        sliceContainers.className = 'RouteProgressSlicesContainer';

        if (stops) {
            for (var stop = 0, stopsLength = stops.length; stop < stopsLength; stop++) {
                sliceContainers.appendChild(this.createStopElement(stops[stop], route));
            }
        }

        return sliceContainers.outerHTML;
    };

    this.createDataHover = function (stop, route) {
      const timestamps = {
        actualArrival: null,
        actualDeparture: null,
        plannedArrival: null,
        plannedDeparture: null,
        projectedArrival: null,
        projectedDeparture: null,
        baseLineArrival: null,
        baseLineDeparture: null,
      };

      Object.keys(timestamps).forEach(key => {
        timestamps[key] = stop[key] && Monet.Format.DateTime.formatToLocale(stop[key]);
      });

      const generalFunctions = new Greenmile.TimeWindow.GeneralFunctions();

      return JSON.stringify({
        plannedSize1: stop.plannedSize1 || 0,
        plannedSize2: stop.plannedSize2 || 0,
        plannedSize3: stop.plannedSize3 || 0,
        actualSize1: stop.actualSize1 || 0,
        actualSize2: stop.actualSize2 || 0,
        actualSize3: stop.actualSize3 || 0,
        key: stop?.location?.key ?? "",
        description: stop?.location?.description ?? "",
        timestamps,
        primaryDriver: route.attributes.primaryDriver,
        step: {
          actual: route.get("stops")?.findIndex(stopFind => stopFind.id === stop.id) + 1,
          total: route.get("stops")?.length
        },
        tw: generalFunctions.getTimeWindowObject(stop.location),
        statusClass: checkStopStatus(stop),
        serviceStatus: checkServiceStatus(stop),
        cloneDate: stop.cloneDate,
        status: stop.deliveryStatus === 'PARTIALLY_DELIVERED' ? 'PARTIALLY_DELIVERED' : stop.deliveryStatus,
      });
    };

    this.createStopElement = function (stop, route) {
        var sliceElement = document.createElement('div');
        var showInfo = "App.Views.RouteProgress.showInfo(this, event);";
        var mouseOutSlice = "App.Views.RouteProgress.mouseOutSlice(this);";

        sliceElement.className = 'timeSlice ' + checkServiceStatus(stop) + ' ' + checkStopStatus(stop);

        if (stop.location) {
            var description = (stop.location.description)? stop.location.description : '';
            sliceElement.setAttribute('popOverHeader', stop.location.key + " " + description);
        }

        sliceElement.setAttribute('data-hover', this.createDataHover(stop, route));
        sliceElement.setAttribute('routeId', route.get('id'));
        sliceElement.setAttribute('stopId', stop.id);
        sliceElement.setAttribute('onmouseover', showInfo);
        sliceElement.setAttribute('onmouseout', mouseOutSlice);
        sliceElement.setAttribute('onblur', mouseOutSlice);
        sliceElement.setAttribute('onclick', `App.Views.RouteProgress.goToRouteDetails(${route.get('id')}, ${stop.id})`);

        var positionInfo = this.converStopTimeToPosition(stop);

        sliceElement.style.left = positionInfo.left + 'px';
        sliceElement.style.width = positionInfo.width + 'px';

        return sliceElement;
    };

    this.getArriveAndDepartureByStopStatus = function (stop) {
      const result = {}
      if (stop.cancelCode) {
        result.arrivalTime = stop.projectedArrival || stop.plannedArrival;
        result.departureTime = stop.projectedDeparture || stop.plannedDeparture;
      } else {
        result.arrivalTime = stop.actualArrival || stop.projectedArrival;
        result.departureTime = stop.actualDeparture || stop.projectedDeparture;
      }

      return result;
    }

    this.converStopTimeToPosition = function (stop) {

        var positionInfo = {
            width: 0,
            left: 0
        };
        const stopTime = this.getArriveAndDepartureByStopStatus(stop);
        var utils = new Greenmile.RouteProgress.Utils();
        var initialPosition = stopTime.arrivalTime;
        var finalPosition = stopTime.departureTime;

        var min = utils.getDuration(App.Forms.RouteProgress.bound.min);
        var minDuration = ((min.days * 24 * 60) + (min.hours * 60) + (min.weeks * 7 * 24 * 60));

        initialPosition = utils.getDuration(initialPosition);
        finalPosition = utils.getDuration(finalPosition);

        var initialPositionDuration = ((initialPosition.days * 24 * 60) + (initialPosition.hours * 60) + (initialPosition.weeks * 7 * 24 * 60) + initialPosition.minutes);
        var finalPositionDuration = ((finalPosition.days * 24 * 60) + (finalPosition.hours * 60) + (finalPosition.weeks * 7 * 24 * 60) + finalPosition.minutes);

        positionInfo.width = (finalPositionDuration - initialPositionDuration) * 2;

        positionInfo.left = (initialPositionDuration - minDuration) * 2;

        return positionInfo;

    };








    this.createTimeSliceColumns = function () {

        var timeSlices = App.Forms.RouteProgress.timeSlices;
        var columnsContainer = document.createElement('div');

        columnsContainer.className = 'RouteProgressTimeSliceColumnContainer';
        columnsContainer.style.width = (timeSlices.length * 120) + 'px';

        for (var slice = 0, l = timeSlices.length; slice < l; slice++) {

            columnsContainer.appendChild(this.createTimeSliceColumnElement(slice));

        }

        return columnsContainer.outerHTML;

    };

    this.createTimeSliceColumnElement = function (i) {

        var sliceCell = document.createElement('div');
        sliceCell.className = 'RouteProgressTimeSliceColumn';
        sliceCell.style.left = (i * 120) + 'px';

        return sliceCell;

    };

    this.createTimeSliceHeaders = function () {

        var timeSlices = App.Forms.RouteProgress.timeSlices;
        var columnsContainer = document.createElement('div');
        columnsContainer.className = 'RouteProgressTimeSliceHeaderContainer';
        columnsContainer.style.width = (timeSlices.length * 120) + 'px';

        for (var slice = 0, l = timeSlices.length; slice < l; slice++) {

            columnsContainer.appendChild(this.createTimeSliceHederElement(slice, timeSlices[slice]));

        }

        return columnsContainer.outerHTML;

    };

    this.createTimeSliceHederElement = function (i, time) {
        const timeFormatted = Monet.Format.Time.formatToLocale(time);

        const sliceCell = document.createElement('div');
        sliceCell.className = 'RouteProgressTimeSliceHeader';
        sliceCell.appendChild(document.createTextNode(timeFormatted));
        sliceCell.style.left = (i * 120) + 'px';

        return sliceCell;
    };

    this.createCurrentTime = function () {

        var utils = new Greenmile.RouteProgress.Utils();
        var currentTimeEl = document.createElement('div');
        var min = utils.getDuration(App.Forms.RouteProgress.bound.min);
        var minDuration = ((min.days * 24 * 60) + (min.hours * 60) + (min.weeks * 7 * 24 * 60));
        var now = utils.getDuration(new Date());
        var nowDuration = (now.days * 24 * 60) + (now.hours * 60) + (now.weeks * 7 * 24 * 60) + now.minutes;
        var durationUntilToday = nowDuration - minDuration;
        var position = durationUntilToday * 2;

        currentTimeEl.className = 'RouteProgressCurrentTime';
        currentTimeEl.style.left = position + 'px';

        return currentTimeEl.outerHTML;

    };

};
